import {Component} from '@angular/core';
import {NavParams} from 'ionic-angular';
import {AppSettings} from '../../config/app-settings';
import {Navigation} from '../../core/navigation';
import {PageRef} from '../../core/core.module';

@Component({
  selector: 'page-tabs',
  templateUrl: 'tabs.html'
})

export class TabsPage {
  mySelectedIndex: number;
  
  constructor(
    public navParams: NavParams,
    public menu: Navigation,
    public pageRef: PageRef,
    public settings: AppSettings
    ) {
    this.mySelectedIndex = navParams.data.tabIndex || 0;
  }

  public getPage(name){
    return this.pageRef.get(name);
  }
}



// WEBPACK FOOTER //
// ./src/pages/tabs/tabs.ts